import FormDialog from "../../helpers/FormDialog";
import { Provinces, Districts, Sectors, Cells, Villages } from "rwanda";
import { useState, useEffect } from "react";

export default function CivilStatusEdit({
  open,
  onSuccess,
  setOpen,
  resourceId,
  value,
  setValue0,
}) {
  const [fatherInLawLocationData, setFatherInLawLocationData] = useState({
    provinces: Provinces(),
    districts: [],
    sectors: [],
    cells: [],
    villages: [],
  });

  const [motherInLawLocationData, setMotherInLawLocationData] = useState({
    provinces: Provinces(),
    districts: [],
    sectors: [],
    cells: [],
    villages: [],
  });

  useEffect(() => {
    if (open) {
      // Initialize fatherInLaw's Location
      const initializeFatherInLawLocation = () => {
        const fp = value.fatherInLawProvince;
        if (fp) {
          const districts = Districts(fp);
          const fd = value.fatherInLawDistrict;
          const sectors = fd ? Sectors(fp, fd) : [];
          const fs = value.fatherInLawSector;
          const cells = fs ? Cells(fp, fd, fs) : [];
          const fc = value.fatherInLawCell;
          const villages = fc ? Villages(fp, fd, fs, fc) : [];

          setFatherInLawLocationData((prev) => ({
            ...prev,
            districts,
            sectors,
            cells,
            villages,
          }));
        }
      };

      // Initialize motherInLaw's Location
      const initializeMotherInLawLocation = () => {
        const mp = value.motherInLawProvince;
        if (mp) {
          const districts = Districts(mp);
          const md = value.motherInLawDistrict;
          const sectors = md ? Sectors(mp, md) : [];
          const ms = value.motherInLawSector;
          const cells = ms ? Cells(mp, md, ms) : [];
          const mc = value.motherInLawCell;
          const villages = mc ? Villages(mp, md, ms, mc) : [];

          setMotherInLawLocationData((prev) => ({
            ...prev,
            districts,
            sectors,
            cells,
            villages,
          }));
        }
      };

      initializeFatherInLawLocation();
      initializeMotherInLawLocation();
    }
  }, [open, value]);
  const fields = [
    {
      name: "spouseName",
      label: "Name of your spouse",
      type: "text",
      value: value["spouseName"],
      setValue: (val) => setValue0("spouseName", val),
      required: true,
    },

    {
      name: "fatherInLawResidence",
      label: "fatherInLaw's Details",
      type: "group",
      fields: [
        {
          name: "fatherInLawName",
          label: "Names of your fatherInLaw:",
          type: "text",
          value: value["fatherInLawName"],
          required: true,
          setValue: (val) => setValue0("fatherInLawName", val),
        },
        {
          name: "fatherInLawProvince",
          label: "Province",
          type: "select",
          value: value["fatherInLawProvince"],
          required: true,
          values: fatherInLawLocationData.provinces.map((province) => ({
            label: province,
            value: province,
          })),
          setValue: (val) => {
            const districts = Districts(val);
            setFatherInLawLocationData((prev) => ({
              ...prev,
              districts,
              sectors: [],
              cells: [],
              villages: [],
            }));
            setValue0("fatherInLawProvince", val);
            setValue0("fatherInLawDistrict", "");
            setValue0("fatherInLawSector", "");
            setValue0("fatherInLawCell", "");
            setValue0("fatherInLawVillage", "");
          },
        },
        {
          name: "fatherInLawDistrict",
          label: "District",
          type: "select",
          value: value["fatherInLawDistrict"],
          required: true,
          values: fatherInLawLocationData.districts.map((district) => ({
            label: district,
            value: district,
          })),
          setValue: (val) => {
            const sectors = Sectors(value["fatherInLawProvince"], val);
            setFatherInLawLocationData((prev) => ({
              ...prev,
              sectors: sectors || [],
              cells: [],
              villages: [],
            }));
            setValue0("fatherInLawDistrict", val);
            setValue0("fatherInLawSector", "");
            setValue0("fatherInLawCell", "");
            setValue0("fatherInLawVillage", "");
          },
        },
        {
          name: "fatherInLawSector",
          label: "Sector",
          type: "select",
          value: value["fatherInLawSector"],
          required: true,
          values: fatherInLawLocationData.sectors.map((sector) => ({
            label: sector,
            value: sector,
          })),
          setValue: (val) => {
            const cells = Cells(
              value["fatherInLawProvince"],
              value["fatherInLawDistrict"],
              val
            );
            setFatherInLawLocationData((prev) => ({
              ...prev,
              cells: cells || [],
              villages: [],
            }));
            setValue0("fatherInLawSector", val);
            setValue0("fatherInLawCell", "");
            setValue0("fatherInLawVillage", "");
          },
        },
        {
          name: "fatherInLawCell",
          label: "Cell",
          type: "select",
          value: value["fatherInLawCell"],
          required: true,
          values: fatherInLawLocationData.cells.map((cell) => ({
            label: cell,
            value: cell,
          })),
          setValue: (val) => {
            const villages = Villages(
              value["fatherInLawProvince"],
              value["fatherInLawDistrict"],
              value["fatherInLawSector"],
              val
            );
            setFatherInLawLocationData((prev) => ({
              ...prev,
              villages: villages || [],
            }));
            setValue0("fatherInLawCell", val);
            setValue0("fatherInLawVillage", "");
          },
        },
        {
          name: "fatherInLawVillage",
          label: "Village",
          type: "select",
          value: value["fatherInLawVillage"],
          required: true,
          values: fatherInLawLocationData.villages.map((village) => ({
            label: village,
            value: village,
          })),
          setValue: (val) => setValue0("fatherInLawVillage", val),
        },
        {
          name: "fatherInLawStreet",
          label: "father-In-Law Street",
          type: "text",
          value: value["fatherInLawStreet"],
          required: true,
          setValue: (val) => setValue0("fatherInLawStreet", val),
        },
        {
          name: "fatherInLawHouseNo",
          label: "father-In-Law House No",
          type: "text",
          value: value["fatherInLawHouseNo"],
          required: true,
          setValue: (val) => setValue0("fatherInLawHouseNo", val),
        },
        {
          name: "fatherInLawVillageLeaderName",
          label: "fatherInLaw Village Leader Name",
          type: "text",
          value: value["fatherInLawVillageLeaderName"],
          required: true,
          setValue: (val) => setValue0("fatherInLawVillageLeaderName", val),
        },
        {
          name: "fatherInLawVillageLeaderMobile",
          label: "fatherInLaw Village Leader Phone",
          type: "tel",
          value: value["fatherInLawVillageLeaderMobile"],
          required: true,
          setValue: (val) => setValue0("fatherInLawVillageLeaderMobile", val),
        },
      ],
    },
    {
      name: "motherInLawResidence",
      label: "mother-In-Law's Details",
      type: "group",
      fields: [
        {
          name: "motherInLawName",
          label: "Name of your Mother-In-Law",
          type: "text",
          value: value["motherInLawName"],
          required: true,
          setValue: (val) => setValue0("motherInLawName", val),
        },
        {
          name: "motherInLawProvince",
          label: "Province",
          type: "select",
          value: value["motherInLawProvince"],
          required: true,
          values: motherInLawLocationData.provinces.map((province) => ({
            label: province,
            value: province,
          })),
          setValue: (val) => {
            const districts = Districts(val);
            setMotherInLawLocationData((prev) => ({
              ...prev,
              districts,
              sectors: [],
              cells: [],
              villages: [],
            }));
            setValue0("motherInLawProvince", val);
            setValue0("motherInLawDistrict", "");
            setValue0("motherInLawSector", "");
            setValue0("motherInLawCell", "");
            setValue0("motherInLawVillage", "");
          },
        },
        {
          name: "motherInLawDistrict",
          label: "District",
          type: "select",
          value: value["motherInLawDistrict"],
          required: true,
          values: motherInLawLocationData.districts.map((district) => ({
            label: district,
            value: district,
          })),
          setValue: (val) => {
            const sectors = Sectors(value["motherInLawProvince"], val);
            setMotherInLawLocationData((prev) => ({
              ...prev,
              sectors: sectors || [],
              cells: [],
              villages: [],
            }));
            setValue0("motherInLawDistrict", val);
            setValue0("motherInLawSector", "");
            setValue0("motherInLawCell", "");
            setValue0("motherInLawVillage", "");
          },
        },
        {
          name: "motherInLawSector",
          label: "Sector",
          type: "select",
          value: value["motherInLawSector"],
          required: true,
          values: motherInLawLocationData.sectors.map((sector) => ({
            label: sector,
            value: sector,
          })),
          setValue: (val) => {
            const cells = Cells(
              value["motherInLawProvince"],
              value["motherInLawDistrict"],
              val
            );
            setMotherInLawLocationData((prev) => ({
              ...prev,
              cells: cells || [],
              villages: [],
            }));
            setValue0("motherInLawSector", val);
            setValue0("motherInLawCell", "");
            setValue0("motherInLawVillage", "");
          },
        },
        {
          name: "motherInLawCell",
          label: "Cell",
          type: "select",
          value: value["motherInLawCell"],
          required: true,
          values: motherInLawLocationData.cells.map((cell) => ({
            label: cell,
            value: cell,
          })),
          setValue: (val) => {
            const villages = Villages(
              value["motherInLawProvince"],
              value["motherInLawDistrict"],
              value["motherInLawSector"],
              val
            );
            setMotherInLawLocationData((prev) => ({
              ...prev,
              villages: villages || [],
            }));
            setValue0("motherInLawCell", val);
            setValue0("motherInLawVillage", "");
          },
        },
        {
          name: "motherInLawVillage",
          label: "Village",
          type: "select",
          value: value["motherInLawVillage"],
          required: true,
          values: motherInLawLocationData.villages.map((village) => ({
            label: village,
            value: village,
          })),
          setValue: (val) => setValue0("motherInLawVillage", val),
        },
        {
          name: "motherInLawStreet",
          label: "motherInLaw Street",
          type: "text",
          value: value["motherInLawStreet"],
          required: true,
          setValue: (val) => setValue0("motherInLawStreet", val),
        },
        {
          name: "motherInLawHouseNo",
          label: "Mother-In-Law House No",
          type: "text",
          value: value["motherInLawHouseNo"],
          required: true,
          setValue: (val) => setValue0("motherInLawHouseNo", val),
        },
        {
          name: "motherInLawVillageLeaderName",
          label: "Mother-In-Law Village Leader Name",
          type: "text",
          value: value["motherInLawVillageLeaderName"],
          required: true,
          setValue: (val) => setValue0("motherInLawVillageLeaderName", val),
        },
        {
          name: "motherInLawVillageLeaderMobile",
          label: "Mother-In-Law Village Leader Phone",
          type: "tel",
          value: value["motherInLawVillageLeaderMobile"],
          required: true,
          setValue: (val) => setValue0("motherInLawVillageLeaderMobile", val),
        },
      ],
    },
  ];

  return (
    <FormDialog
      maxWidth={"md"}
      open={open}
      onSuccess={onSuccess}
      setOpen={setOpen}
      url={
        open === 1
          ? "/api/resource/create"
          : `/api/resource/civil-status/update/${resourceId}`
      }
      title={open === 1 ? "Create Parent Details" : "Edit Civil Status Details"}
      fields={fields}
    />
  );
}
